import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { ConfirmationBox } from '../../components/ConfirmationBox';
import Button from '@material-ui/core/Button';
import Clock from 'react-live-clock';
import Header from '../../layout/Header';
import Subheader from '../../layout/Subheader';
import Loading from '../../components/Loading';
import useStyles from './style';
import api from '../../services/api';
import { getUser, updateTimeRegistered } from '../../services/auth';
import { CreatorsCardsDots } from '../../store/ducks/cardsDots';
import { useMessageBox } from '../../context/MessageBox';
import Filter from './Filter';
import { AccordionSummary, Grid, Input, Typography } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Paper from '@material-ui/core/Paper';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MaterialTable from 'material-table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { useParams } from 'react-router-dom';

export default function TimeTable() {
  const { warn } = useParams();
  const [confirmationBox, setConfirmationBox] = useState({
    show: false,
    type: '',
    callback: () => {},
  });
  const [isLoading, setLoading] = useState(true);
  const [getTimes, setTimes] = useState([]);
  const [tableData, setTableData] = useState();
  const [totalData, setTotalData] = useState([]);
  const [horaSobraFalta, setHoraSobraFalta] = useState();
  const [dateFilter, setDateFilter] = useState(new Date());

  const dispatch = useDispatch();
  const classes = useStyles();
  const { setMessageData } = useMessageBox();

  const userLogged = getUser();

  const findLastTimes = async () => {
    try {
      const response = await api.get('CartoesPontos/ConsultarLoginId', {
        params: {
          loginId: userLogged.loginId,
          qtdRegistros: 1,
          hoje: true
        },
      });

      if (response?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(response?.data?.complemento?.mensagensBox);
        return;
      }

      if (response?.data?.status.toLowerCase() === 'inconsistencia') {
        toast.error(response?.data?.resposta[0].message);
        return;
      }

      if (response.data.resposta[0]) {
        setTimes(response.data.resposta[0]);
        calcHours(response.data.resposta[0]);
      }
    } catch (err) {
      toast.error('Detectamos um problema interno! tente novamente em instantes.');
    }
    setLoading(false);
  };

  const onSubmitTime = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      const response = await api.post(`CartoesPontos/RegistarPonto?loginId=${userLogged.loginId}`);

      if (response?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(response?.data?.complemento?.mensagensBox);
      }

      if (response.data.status !== 'Sucesso') {
        if (response.data.resposta) {
          if (response.data.resposta.length > 0) {
            response.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        setLoading(false);
        return null;
      }

      if (response?.data?.resposta?.obrigaRegistrarPonto !== null) {
        updateTimeRegistered(response?.data?.resposta?.obrigaRegistrarPonto);
      }

      setTimes(response.data.resposta);
      calcHours(response.data.resposta);
      dispatch(CreatorsCardsDots.addCardsDots(response.data.resposta));
    } catch (err) {
      toast.error('Detectamos um problema interno! tente novamente em instantes.');
    }
    setLoading(false);
  };

  const handleConfirmationBox = (type, callback) => {
    setConfirmationBox({
      show: true,
      type,
      callback,
    });
  };

  const calcMilisecondsDifference = (startDate, endDate) => {
    if (startDate && endDate) {
      const endTime = endDate instanceof Date ? endDate.getTime() : new Date(endDate).getTime();

      const startTime =
        startDate instanceof Date ? startDate.getTime() : new Date(startDate).getTime();

      return endTime - startTime;
    } else return 0;
  };

  const getDateTimeFromMilliseconds = (dataPonto, millisecondsDiff) => {
    const date = new Date(null);
    if (millisecondsDiff.toString().includes('-')) {
      date.setTime(Number(millisecondsDiff.toString().replace('-', '')));
    } else {
      date.setTime(millisecondsDiff);
    }

    const time = date.toISOString().substr(11, 8);
    const hours = time.substr(0, 2);
    const minutes = time.substr(3, 2);
    const seconds = 0;

    return new Date(new Date(dataPonto).setHours(hours, minutes, seconds));
  };

  const calcHours = (response) => {
    let millisecondsDiff = 0;

    const horasTrabalho = response.cargaHoraria;

    if (response.ponto1 && response.ponto2) {
      millisecondsDiff = calcMilisecondsDifference(response.ponto1, response.ponto2);
    }
    if (response.ponto3 && response.ponto4) {
      millisecondsDiff += calcMilisecondsDifference(response.ponto3, response.ponto4);
    }

    if (millisecondsDiff > 0) {
      const workedDateTime = getDateTimeFromMilliseconds(response.dataPonto, millisecondsDiff);

      if (workedDateTime.toTimeString().substr(0, 5) === '00:00') {
        setHoraSobraFalta(horasTrabalho);
      } else {
        const dateTimeWorked = new Date(
          new Date(response.dataPonto).setHours(
            horasTrabalho.split(':')[0],
            horasTrabalho.split(':')[1],
            0,
          ),
        );
        const millisecondsLeft = calcMilisecondsDifference(dateTimeWorked, workedDateTime);

        setHoraSobraFalta(
          getDateTimeFromMilliseconds(response.dataPonto, millisecondsLeft)
            .toTimeString()
            .substr(0, 5),
        );
      }
    } else {
      setHoraSobraFalta(horasTrabalho);
    }
  };

  const updateFilter = async (filteredDate) => {
    setDateFilter(filteredDate);
    await findHistoryTimes(filteredDate);
  };

  const findHistoryTimes = async (filteredDate) => {
    const payload = {
      mes: new Date(filteredDate).getMonth() + 1,
      ano: new Date(filteredDate).getFullYear(),
      loginId: userLogged.loginId,
      ordemDescedente: true,
      telaDePonto: true,
    };

    try {
      setLoading(true);

      const response = await api.post('Relatorios/Relatorio007CartaoPonto', payload);

      if (response?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(response?.data?.complemento?.mensagensBox);
        return;
      }

      if (response?.data?.status.toLowerCase() === 'inconsistencia') {
        toast.error(response?.data?.resposta[0].message);
        return;
      }

      if (response.data.status !== 'Sucesso') {
        if (response.data.resposta) {
          if (response.data.resposta.length > 0) {
            response.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
      } else {
        setTableData(response.data.resposta.itens);

        setTotalData([
          {
            diaDoMes: '',
            cargaHoraria: '',
            ponto1: '',
            ponto2: '',
            ponto3: '',
            ponto4: '',
            motivo: '',
            horasTrabalhadas: response.data.resposta.totalizador.horasTrabalhadas,
            sobraFalta: response.data.resposta.totalizador.sobraFalta,
          },
        ]);
      }
    } catch (error) {
      if (error?.response?.data?.resposta) {
        if (error?.response?.data?.status.toLowerCase() === 'inconsistencia') {
          if (error.response?.data.resposta.length > 0) {
            error.response?.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          } else {
            toast.error(error.response?.data?.resposta[0].message);
          }
        }

        if (error?.response?.data?.complemento?.mensagensBox?.length > 0) {
          setMessageData(error?.response?.data?.complemento?.mensagensBox);
          return;
        }
      }

      console.log(error);
    } finally {
      setLoading(false);
      if (document.getElementsByClassName('MuiTableRow-head')[1]) {
        document.getElementsByClassName('MuiTableRow-head')[1].style.display = 'none';
      }
    }
  };

  const exportDataToPDF = async (filteredDate) => {
    setLoading(true);
    try {
      const url = 'Relatorios/Relatorio007CartaoPontoDownloadPDF';

      const payload = {
        mes: new Date(filteredDate).getMonth() + 1,
        ano: new Date(filteredDate).getFullYear(),
        loginId: userLogged.loginId,
        ordemDescedente: false,
        telaDePonto: false,
      };

      const relatorio = await api.post(url, payload);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      if (relatorio.data.status !== 'Sucesso') {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        return;
      }

      const a = document.createElement('a');
      a.href =
        'data:' +
        relatorio.data.resposta.contentType +
        ';base64,' +
        relatorio.data.resposta.fileContents;
      a.download = relatorio.data.resposta.fileDownloadName;
      a.click();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (warn === 'warn') {
      toast.warn('Necessário registrar ponto para acessar o sistema!');
    }
  }, []);

  useEffect(() => {
    const initialize = async () => {
      await findLastTimes();
      await findHistoryTimes(new Date().getTime());
    };
    initialize();

    return () => {
      setTableData([]);
    };
  }, []);

  return (
    <div className={classes.root}>
      {confirmationBox.show && (
        <ConfirmationBox
          data={confirmationBox}
          setConfirmationBox={setConfirmationBox}
        ></ConfirmationBox>
      )}
      <Header />
      <Subheader title="Registrar Ponto" back={'/app/home'} />

      <div className={classes.content}>
        <div className={classes.rootForm}>
          <div>
            {isLoading ? (
              <Loading />
            ) : (
              <>
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                    <Typography className={classes.heading}>Horas</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container justifyContent="center">
                      <Grid container justifyContent="center">
                        <Grid item xs={1}>
                          <label className={classes.label}>Hora atual</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Clock
                              className={classes.inputActualHour}
                              format={'HH:mm:ss'}
                              ticking={true}
                              timezone={'America/Sao_Paulo'}
                            />
                          </Paper>
                        </Grid>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                    <Typography className={classes.heading}>Pontos</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid
                        container
                        justifyContent="space-evenly"
                        alignItems="baseline"
                        spacing={1}
                      >
                        <Grid item xs={1}>
                          <label className={classes.label}>Data</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              style={{ textTransform: 'uppercase !important' }}
                              className={classes.inputTime}
                              classes={{ input: classes.inputText }}
                              disabled
                              placeholder="00/00/0000"
                              value={
                                getTimes.dataPonto
                                  ? new Date(getTimes.dataPonto).toLocaleDateString('pt-BR')
                                  : '00/00/0000'
                              }
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={1}>
                          <label className={classes.label}>Entrada</label>
                          <Paper className={classes.small} elevation={0}>
                            <Input
                              style={{ textTransform: 'uppercase !important' }}
                              className={classes.inputTime}
                              classes={{ input: classes.inputText }}
                              disabled
                              placeholder="00:00"
                              value={
                                getTimes.ponto1
                                  ? new Date(getTimes.ponto1).toTimeString().substr(0, 5)
                                  : '00:00'
                              }
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={1}>
                          <label className={classes.label}>Saida Almoço</label>
                          <Paper className={classes.small} elevation={0}>
                            <Input
                              style={{ textTransform: 'uppercase !important' }}
                              className={classes.inputTime}
                              disabled
                              classes={{ input: classes.inputText }}
                              placeholder="00:00"
                              value={
                                getTimes.ponto2
                                  ? new Date(getTimes.ponto2).toTimeString().substr(0, 5)
                                  : '00:00'
                              }
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={1}>
                          <label className={classes.label}>Retorno Almoço</label>
                          <Paper className={classes.small} elevation={0}>
                            <Input
                              style={{ textTransform: 'uppercase !important' }}
                              className={classes.inputTime}
                              classes={{ input: classes.inputText }}
                              disabled
                              placeholder="00:00"
                              value={
                                getTimes.ponto3
                                  ? new Date(getTimes.ponto3).toTimeString().substr(0, 5)
                                  : '00:00'
                              }
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={1}>
                          <label className={classes.label}>Saída</label>
                          <Paper className={classes.small} elevation={0}>
                            <Input
                              style={{ textTransform: 'uppercase !important' }}
                              className={classes.inputTime}
                              classes={{ input: classes.inputText }}
                              disabled
                              placeholder="00:00"
                              value={
                                getTimes.ponto4
                                  ? new Date(getTimes.ponto4).toTimeString().substr(0, 5)
                                  : '00:00'
                              }
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={1}>
                          <label className={classes.label}>Sobra/Falta</label>
                          <Paper className={classes.small} elevation={0}>
                            <Input
                              id="leftHour"
                              style={{ textTransform: 'uppercase !important' }}
                              className={classes.inputTime}
                              classes={{ input: classes.inputText }}
                              placeholder="00:00"
                              disabled
                              value={horaSobraFalta}
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={2}>
                          <Button
                            variant="contained"
                            className={classes.buttonRegister}
                            onClick={(event) =>
                              handleConfirmationBox('confirmacaoPonto', () => {
                                onSubmitTime(event);
                              })
                            }
                          >
                            Registrar Ponto
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                    <Typography className={classes.heading}>Registros</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Filter
                          dateFilter={dateFilter}
                          handleFilter={updateFilter}
                          handleExportToPDF={exportDataToPDF}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <MaterialTable
                          className={classes.table}
                          options={{
                            showTitle: false,
                            search: false,
                            toolbar: false,
                            filtering: false,
                            paging: false,
                            rowStyle: rowData => ({
                              backgroundColor: rowData.corFundo ? rowData.corFundo : 'auto',
                              color: rowData.corFonte ? rowData.corFonte : 'auto',
                            })
                          }}
                          title="Multiple Actions Preview"
                          columns={[
                            {
                              title: 'Dia do Mês',
                              field: 'diaDoMes',
                              type: 'date',
                              cellStyle: {
                                fontSize: '13px',
                              },

                              render: (item) => (
                                <span
                                  style={
                                    item.diaDaSemana === 'SÁBADO' || item.diaDaSemana === 'DOMINGO'
                                      ? { color: 'red' }
                                      : {}
                                  }
                                >
                                  {item.diaDoMes}
                                </span>
                              ),
                            },
                            {
                              title: 'Carga Horária',
                              field: 'cargaHoraria',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                            },
                            {
                              title: 'Entrada',
                              field: 'ponto1',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                            },
                            {
                              title: 'Saída Almoço',
                              field: 'ponto2',
                              type: 'time',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                            },
                            {
                              title: 'Retorno Almoço',
                              field: 'ponto3',
                              type: 'time',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                            },
                            {
                              title: 'Saida',
                              field: 'ponto4',
                              type: 'time',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                            },
                            {
                              title: 'Motivo',
                              field: 'motivo',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                            },
                            {
                              title: 'Horas Trabalhadas',
                              field: 'horasTrabalhadas',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                            },
                            {
                              title: 'Sobra/Falta',
                              field: 'sobraFalta',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                              render: (item) => (
                                <span style={item.sobraFalta.includes('-') ? { color: 'red' } : {}}>
                                  {item.sobraFalta}
                                </span>
                              ),
                            },
                          ]}
                          data={tableData && tableData}
                        />
                        <MaterialTable
                        style={{ boxShadow: 'none' }}
                          options={{
                            showTitle: false,
                            search: false,
                            toolbar: false,
                            headerStyle: {
                              backgroundColor: '#F5F5F5',
                              textTransform: 'none',
                              fontSize: '15px',
                            },
                            filtering: false,
                            paging: false,
                          }}
                          title="Multiple Actions Preview"
                          columns={[
                            {
                              title: 'diaDoMes',
                              field: 'diaDoMes',
                              type: 'date',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                              headerStyle: {
                                display: 'none',
                              },
                            },
                            {
                              field: 'cargaHoraria',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                              headerStyle: {
                                display: 'none',
                              },
                            },
                            {
                              title: 'Entrada',
                              field: 'ponto1',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                              headerStyle: {
                                display: 'none',
                              },
                            },
                            {
                              title: 'Saída Almoço',
                              field: 'ponto2',
                              type: 'time',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                              headerStyle: {
                                display: 'none',
                              },
                            },
                            {
                              title: 'Retorno Almoço',
                              field: 'ponto3',
                              type: 'time',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                              headerStyle: {
                                display: 'none',
                              },
                            },
                            {
                              title: 'Saida',
                              field: 'ponto4',
                              type: 'time',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                              headerStyle: {
                                display: 'none',
                              },
                            },
                            {
                              title: 'Motivo',
                              field: 'motivo',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                              headerStyle: {
                                display: 'none',
                              },
                            },
                            {
                              title: 'Horas Trabalhadas',
                              field: 'horasTrabalhadas',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                              headerStyle: {
                                display: 'none',
                              },
                            },
                            {
                              title: 'Sobra/Falta',
                              field: 'sobraFalta',
                              cellStyle: {
                                fontSize: '13px',
                                padding: '8px 20px',
                              },
                              headerStyle: {
                                display: 'none',
                              },
                              render: (item) => (
                                <span style={item.sobraFalta.includes('-') ? { color: 'red' } : {}}>
                                  {item.sobraFalta}
                                </span>
                              ),
                            },
                          ]}
                          data={totalData && totalData}
                        />
                        <div
                        style={{
                          backgroundColor: 'white',
                          marginBottom: '20px',
                          boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
                          display: 'flex',
                          flexDirection: 'column',
                          padding: '8px',
                          borderRadius: '4px'
                        }}>
                        <span style={{ fontWeight: 'bold', marginBottom: '5px' }}>Motivos:</span>
                        <span>Feriado, 1 - Ausência Justificada, 2 - Ausência Justificada Com Atestado, 3 - Ausência Não Justificada, 4 - Treinamento, 5 - Férias</span>
                      </div>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
